/** Fee/expense routes are mounted under /Admin and /Teacher (bursar). */

export function getFinanceBaseFromPath(pathname) {
    return String(pathname || "").startsWith("/Teacher") ? "/Teacher" : "/Admin";
}

export function feeRecordPath(pathname, recordId) {
    return `${getFinanceBaseFromPath(pathname)}/fees/record/${recordId}`;
}

export function expenseDetailPath(pathname, expenseId) {
    return `${getFinanceBaseFromPath(pathname)}/expenses/detail/${expenseId}`;
}
